
<template>
  <a-modal
    :title="title"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          v-show="false"
          label="projectId"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['projectId']"
            :disabled="editable || showable"
          />
        </a-form-item>
        <a-form-item
          label="项目名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            placeholder="请输入项目名称"
            :disabled="showable"
            v-decorator="['projectName', {rules: [{required: true, message: '请输入项目名称'}]}]" />
        </a-form-item>

        <a-form-item
          label="项目经理"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            :disabled="showable"
            placeholder="请选择项目经理"
            :filterOption="filterOption"
            style="width: 100%"
            mode="multiple"
            :allowClear="true"
            v-decorator="['projectManagerIdList', {rules: [{required: true, message: '请选择项目经理'}]}]">
            <a-select-option v-for="(action, index) in projectManagerIdList" :key="index" :value="action.value">{{ action.label }}</a-select-option>
          </a-select>
        </a-form-item>

<!--        hasFeedback-->
        <a-form-item
          label="资料员"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            :disabled="showable"
            placeholder="请选择资料员"
            :filterOption="filterOption"
            style="width: 100%"
            mode="multiple"
            :allowClear="true"
            v-decorator="['dataListIdList', {rules: [{required: true, message: '请选择资料员'}]}]">
            <a-select-option v-for="(action, index) in buildListIdList" :key="index" :value="action.value">{{ action.label }}</a-select-option>
          </a-select>
        </a-form-item>

<!--        hasFeedback-->
        <a-form-item
          label="施工员"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            :disabled="showable"
            placeholder="请选择施工员"
            :filterOption="filterOption"
            style="width: 100%"
            mode="multiple"
            :allowClear="true"
            v-decorator="['buildListIdList', {rules: [{required: false, message: '请选择施工员'}]}]">
            <a-select-option v-for="(action, index) in dataListIdList" :key="index" :value="action.value">{{ action.label }}</a-select-option>
          </a-select>
        </a-form-item>

      </a-form>
    </a-spin>
    <template slot="footer" >
      <div v-show="editable || addable">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { FormMixin } from '@/mixins/FormMixin'
import { addObj, getByProjectId, putObj } from '@/api/common/ProjectStaff'
import { dropDownByCode } from '@/api/sys/user'

export default {
  name: 'ProjectStaffAddOrUpdate',
  mixins: [FormMixin],
  data () {
    return {
      confirmLoading: false,
      form: this.$form.createForm(this),
      showable: false,
      permissionList: [],
      projectManagerIdList: null,
      buildListIdList: null,
      dataListIdList: null,
      projectManager: {
        roleCode: 'sx_project_manager'
      },
      buildRole: {
        roleCode: 'sx_data'
      },
      dataRole: {
        roleCode: 'sx_build'
      }
    }
  },
  methods: {
    edit (projectId, type) {
      this.visible = true
      const { form: { setFieldsValue, resetFields } } = this
      dropDownByCode(this.projectManager).then(res => {
        this.projectManagerIdList = res.data
      })

      dropDownByCode(this.buildRole).then(res => {
        this.buildListIdList = res.data
      })
      dropDownByCode(this.dataRole).then(res => {
        this.dataListIdList = res.data
      })
      if (['edit', 'show'].includes(type)) {
        this.confirmLoading = true
        getByProjectId(projectId).then(res => {
          const record = res.data
          this.confirmLoading = false
          this.$nextTick(() => {
            setFieldsValue(pick(record, ['projectId', 'projectName', 'projectManagerIdList', 'buildListIdList', 'dataListIdList']))
          })
        })
      } else {
        resetFields()
      }
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.confirmLoading = true
          try {
            if (this.type === 'add') {
              await addObj(values)
            } else if (this.type === 'edit') {
              await putObj(values)
            }
            setTimeout(() => {
              this.confirmLoading = false
              this.$emit('ok')
              this.handleCancel()
            }, 1500)
          } catch (e) {
            this.confirmLoading = false
            this.$message.error(e.msg)
          }
        }
      })
    },
    handleChange (value) {
      console.log(`Selected: ${value}`)
    },
    popupScroll () {
      console.log('popupScroll')
    }
  }
}
</script>

<style scoped>

</style>
